/**
 * In-game chat.
 *
 * Deliberately small: two rooms, no history beyond a rolling buffer, no
 * threading. Chat is for the sentence you say while doing something else. The
 * forum is where anything worth keeping goes, and the split only works if chat
 * stays disposable.
 *
 * Signed-in only, unlike the forum. There is nothing here worth indexing and a
 * live room full of strangers is a moderation problem the game does not need
 * on its landing page.
 */
export const ChatChannel = {
    WORLD: 'world',
    ALLIANCE: 'alliance',
};
export const CHAT_CHANNELS = [
    { id: ChatChannel.WORLD, name: 'World', blurb: 'Everyone on the server.' },
    { id: ChatChannel.ALLIANCE, name: 'Alliance', blurb: 'Your alliance only.' },
];
export const CHAT_LIMITS = {
    BODY_MAX: 400,
    /** Messages kept per room. Old ones fall off the end. */
    HISTORY: 120,
    /** Milliseconds between messages from one player. */
    COOLDOWN_MS: 1200,
    /** Messages per minute before the connection is told to stop. */
    PER_MINUTE: 20,
};
//# sourceMappingURL=chat.js.map